export default "<h1>404 Page</h1>\n";